import React, {ReactNode} from 'react';
import './ContentSectionWrapper.scss';

interface ContentSectionWrapperProps {
  backgroundColor?: string;
  paddingTop: number;
  paddingBottom: number;
  children?: ReactNode;
}

export const ContentSectionWrapper: React.FC<ContentSectionWrapperProps> = ({
  children,
  backgroundColor,
  paddingTop,
  paddingBottom,
}) => (
  <div
    className="content-section-wrapper"
    style={{
      backgroundColor,
      paddingTop,
      paddingBottom,
    }}
  >
    {children}
  </div>
);
